module.exports = __webpack_public_path__ + "img/top.9ea95cc3.png";